const types = ['EMPLOYEE', 'DRIVER'];

const roles = [
  { value: 'admin', index: 1 },
  { value: 'service_manager', index: 2 },
  { value: 'group_manager', index: 3 },
  { value: 'fleet_manager', index: 4 },
  { value: 'operator', index: 5 },
  { value: 'driver', index: 6 },
  { value: 'driver_loaner', index: 7 },
  { value: 'driver_crew', index: 8 },
  { value: 'operations_lead', index: 9 },
  { value: 'driver_business', index: 10 },
];

export { roles, types };
